import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { signInWithGoogle } from "../lib/authApi";

const GoogleG = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
    />
    <path
      fill="#34A853"
      d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.85.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"
    />
    <path
      fill="#FBBC05"
      d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z"
    />
    <path
      fill="#EA4335"
      d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"
    />
  </svg>
);

// "Continue with Google" using the existing Supabase Google provider. Full-page
// redirect, so on success the page navigates away; on error we surface it.
export const GoogleButton = ({ label = "Continue with Google", testid = "google-auth-btn" }) => {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    setBusy(true);
    try {
      await signInWithGoogle();
    } catch (err) {
      toast.error(err?.message || "Could not start Google sign-in.");
      setBusy(false);
    }
  };
  return (
    <div className="mt-6">
      <div className="flex items-center gap-3">
        <div className="h-px flex-1 bg-white/10" />
        <span className="text-xs font-medium uppercase tracking-wide text-white/40">or</span>
        <div className="h-px flex-1 bg-white/10" />
      </div>
      <button
        type="button"
        data-testid={testid}
        onClick={onClick}
        disabled={busy}
        className="mt-6 flex w-full items-center justify-center gap-3 rounded-full border border-white/15 bg-[#121212] py-3.5 text-base font-semibold text-white transition-transform duration-200 active:scale-[0.98] disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <><GoogleG /> {label}</>}
      </button>
    </div>
  );
};
